var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16c0 8.837 7.163 16 16 16s16-7.163 16-16S24.837 0 16 0 0 7.163 0 16z",
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1 15.708c4.295-1.87 7.159-3.105 8.592-3.7 4.091-1.702 4.942-1.998 5.496-2.008.122-.002.394.028.57.171.15.121.19.285.21.4.02.114.044.375.025.58-.222 2.33-1.181 7.983-1.67 10.592-.206 1.104-.613 1.474-1.006 1.51-.856.079-1.505-.565-2.334-1.108-1.297-.85-2.03-1.38-3.288-2.209-1.455-.959-.512-1.485.317-2.346.217-.226 3.987-3.655 4.06-3.966.01-.039.018-.184-.069-.26-.086-.077-.213-.05-.305-.03-.13.03-2.201 1.4-6.214 4.108-.588.404-1.12.6-1.598.59-.526-.011-1.538-.297-2.29-.542-.923-.3-1.656-.458-1.592-.968.033-.265.398-.536 1.096-.814z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.8b2af838e287e9e408e5a9c1e6de7c9a.svg";
export { ForwardRef as ReactComponent };